import {
    Document,
    PDFViewer,
    Page as PDFPage,
    StyleSheet,
    Text as PDFText,
    View as PDFView,
    Image as PDFImage
} from '@react-pdf/renderer';

/* 🔹 STYLES */
const styles = StyleSheet.create({
    page: {
        position: 'relative'
    },

    container: {
        position: 'absolute',
        top: 0,
        left: 0,
        right: 0,
        bottom: 0
    },

    /* 🔹 FIELD POSITIONS - ADJUSTED BASED ON "NAME" REFERENCE */
    // Name field is at top: 185, left: 115 (this is your reference)

    serial: {
        position: 'absolute',
        top: 70,        // Above name field
        right: 100,     // Right aligned
        fontSize: 15,
        fontWeight: 'bold'
    },

    name: {
        position: 'absolute',
        top: 135,       // Reference position (KEEP AS IS)
        left: 115,      // Reference position (KEEP AS IS)
        fontSize: 10,
        fontWeight: 'bold'
    },

    ageSex: {
        position: 'absolute',
        top: 135,       // Same vertical level as name
        left: 450,      // To the right of name field
        fontSize: 10
    },

    date: {
        position: 'absolute',
        top: 110,       // Same vertical level as name
        left: 475,      // Further right
        fontSize: 10
    },

    uhid: {
        position: 'absolute',
        top: 110,       // Same vertical level as name
        left: 100,      // Rightmost position
        fontSize: 10
    },

    op_no: {
        position: 'absolute',
        top: 110,       // Below name (185 + 30px spacing)
        left: 320,      // Adjusted to match template alignment
        fontSize: 10
    },

    phone: {
        position: 'absolute',
        top: 160,       // Same vertical level as guardian
        left: 450,      // Right side
        fontSize: 10
    },

    address: {
        position: 'absolute',
        top: 160,       // Below guardian (215 + 30px spacing)
        left: 115,      // Aligned with name field
        right: 40,
        fontSize: 10
    },

     consultant: {
        position: 'absolute',
        top: 180,       
        left: 115,      
        fontSize: 10
    },
});

/* 🔹 MAIN COMPONENT */
export const PatientRegistrationPdf25 = ({ data }) => {
    function formatDate(dateString) {
        if (!dateString) return '';
        const date = new Date(dateString);
        const day = String(date.getDate()).padStart(2, '0');
        const month = String(date.getMonth() + 1).padStart(2, '0');
        const year = date.getFullYear();
        return `${day}/${month}/${year}`;
    }

    return (
        <PDFViewer width="100%" height="100%">
            <Document>
                <PDFPage size="A4" style={styles.page}>

                    {/* ✅ BACKGROUND TEMPLATE */}
                    <PDFImage
                        src={`${window.location.origin}/PDf Print Format.png`}
                        style={{
                            position: 'absolute',
                            top: 0,
                            left: 0,
                            width: '100%',
                            height: '100%'
                        }}
                        fixed
                    />

                    {/* ✅ OVERLAY VALUES */}
                    <PDFView style={styles.container}>

                        <PDFText style={styles.serial}>
                            {data?.token_no || ''}
                        </PDFText>

                        <PDFText style={styles.name}>
                            {data?.name || ''}
                        </PDFText>

                        <PDFText style={styles.ageSex}>
                            {data?.age || ''}/{data?.gender || ''}
                        </PDFText>

                        <PDFText style={styles.date}>
                            {formatDate(data?.reg_date)}
                        </PDFText>

                        <PDFText style={styles.uhid}>
                            {data?.uhid || ''}
                        </PDFText>

                        <PDFText style={styles.op_no}>
                            {data?.op_no || ''}
                        </PDFText>

                        <PDFText style={styles.phone}>
                            {data?.mobile || ''}
                        </PDFText>

                        <PDFText style={styles.address}>
                            {data?.address || ''}
                        </PDFText>



                        <PDFText style={styles.consultant}>
                            {data?.consultant || ''}
                        </PDFText>

                        

                    </PDFView>

                </PDFPage>
            </Document>
        </PDFViewer>
    );
};